import {useMemo} from "react";

/**
 * Raildays App integration helper methods
 * i.e. we are being hosted inside the Raildays App
 *
 * @package HOPS
 * @subpackage Helpers
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
const useRaildaysApp = () => {

	return useMemo(() => {
		return {
			isBeingRenderedByRaildaysApp: (!!process.env.REACT_APP_RAILDAYS_SIMULATION_ENABLED || navigator.userAgent.includes("raildays-app="))
		};
	}, []);

};

export default useRaildaysApp;
